const TraitsData = [
    {
        id: 1,
        image: 'https://i.ibb.co/cLr4VNg/matching-initial.png',
        gif: 'https://i.ibb.co/3c5VgPc/matching-larger.gif',
        title: 'Matching',
        description: 'All the traits match with each other!',
    },
    {
        id: 2,
        image: 'https://i.ibb.co/rcWtjxf/drip-initial.png',
        gif: 'https://i.ibb.co/FKnJq5z/drip.gif',
        title: 'Drip',
        description: 'These ErgoSapiens got a bit of style and glimmer.',
    },
    {
        id: 3,
        image: 'https://i.ibb.co/X4r5k4G/topsecret3.png',
        gif: 'https://i.ibb.co/MNZyW1T/featured14.gif',
        title: 'Featured NFTs',
        description: 'Any of the NFTs featured by us will be available!',
    },
];

export default TraitsData;
